import {
  GET_ROSTER_ADHERENCE,
  GET_ROSTER_ADHERENCE_SUCCESS,
  GET_ROSTER_ADHERENCE_ERROR,
  GET_CLIENT_ADHERENCE,
  GET_CLIENT_ADHERENCE_SUCCESS,
  GET_CLIENT_ADHERENCE_ERROR,
} from './constants';

const initialState = {
  // Roster: array of `{clientId, latestPct, trend: number[]}`
  roster: [],
  rosterLoading: false,
  rosterErr: null,
  // Per-client weekly array — keyed by clientId so multiple detail pages
  // can hold their data without overwriting each other.
  byClient: {},
  byClientLoading: false,
  byClientErr: null,
};

export default function adherence(state = initialState, action) {
  switch (action.type) {
    case GET_ROSTER_ADHERENCE:
      return { ...state, rosterLoading: true, rosterErr: null };
    case GET_ROSTER_ADHERENCE_SUCCESS:
      return {
        ...state,
        roster: Array.isArray(action.payload) ? action.payload : [],
        rosterLoading: false,
        rosterErr: null,
      };
    case GET_ROSTER_ADHERENCE_ERROR:
      return { ...state, rosterLoading: false, rosterErr: action.err };

    case GET_CLIENT_ADHERENCE:
      return {
        ...state,
        byClientLoading: true,
        byClientErr: null,
      };
    case GET_CLIENT_ADHERENCE_SUCCESS: {
      const list = Array.isArray(action.payload) ? action.payload : [];
      // We don't get `clientId` echoed in the payload, so we stuff
      // it onto state under a special "_latest" key — the detail page
      // only ever shows one client at a time, so we don't need to
      // multiplex by id. (Keep the multiplex shape on `byClient` for
      // future use.)
      return {
        ...state,
        byClient: { ...state.byClient, _latest: list },
        byClientLoading: false,
        byClientErr: null,
      };
    }
    case GET_CLIENT_ADHERENCE_ERROR:
      return { ...state, byClientLoading: false, byClientErr: action.err };

    default:
      return state;
  }
}
